interface PayPeriodLike {
    startDate: Date;
    endDate: Date;
}

export function payPeriodKey(period: PayPeriodLike): string {
    return `${period.startDate.toISOString()}|${period.endDate.toISOString()}`;
}

export function findRequestedPayPeriodKey(
    periods: PayPeriodLike[],
    requestedStart: string | null
): string | null {
    if (!requestedStart) {
        return null;
    }

    const match = periods.find(
        (period) =>
            period.startDate.toISOString().slice(0, 10) === requestedStart
    );

    return match ? payPeriodKey(match) : null;
}
